import React, { useEffect } from "react";
import { Container } from "@mui/material";
import PageContent from "../../components/layout/container/PageContent";
import PersonForm from "../../components/form/PersonForm";
import { useNavigate, useParams } from "react-router";
import { useSelector } from "react-redux";

const EditMember = () => {
    const params = useParams();
    const navigate = useNavigate();
    const uid = useSelector(state => state.user.uid);

    useEffect(() => {
        if (!Boolean(uid)) {
            navigate("/login");
        }
    }, [uid]);

    return (
        <PageContent showImageHeader={false}>
            <Container maxWidth="md">
                <PersonForm paramId={params.id} paramTopic={params.topic} />
            </Container>
        </PageContent>
    );
};

export default EditMember;
